import { render } from "./TileMedia.vue?vue&type=template&id=24fd13ba"
import script from "./TileMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./TileMedia.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/TileMedia.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24fd13ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24fd13ba', __exports__)) {
    api.reload('24fd13ba', __exports__)
  }
  
  module.hot.accept("./TileMedia.vue?vue&type=template&id=24fd13ba", () => {
    api.rerender('24fd13ba', render)
  })

}


export default __exports__